import { FaGithub, FaLinkedin, FaMapMarkerAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import styles from './Footer.module.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.socialIcons}>
        <a 
          href="https://github.com/JoaoLopes017" 
          target="_blank" 
          rel="noreferrer"
          aria-label="GitHub"
        >
          <FaGithub size={24} />
        </a>
        <a 
          href="https://www.linkedin.com/in/joaolopes017/" 
          target="_blank" 
          rel="noreferrer"
          aria-label="LinkedIn"
        >
          <FaLinkedin size={24} />
        </a>
        <a 
          href="mailto:jonas00101@gmail.com"
          aria-label="Email"
        >
          <MdEmail size={24} />
        </a>
        <a 
          href="https://maps.google.com?q=Rotterdam,Netherlands"
          target="_blank" 
          rel="noreferrer"
          aria-label="Location: Rotterdam, Netherlands"
          title="Rotterdam, Netherlands"
        >
          <FaMapMarkerAlt size={20} />
        </a>
      </div>
      <div className={styles.footerText}>
        <p>© {currentYear} João Lopes. All rights reserved.</p>
        <p>Thank you for visiting!</p>
      </div>
    </footer>
  );
}

export default Footer;
